import React from "react";
import { useDragLayer } from "react-dnd";
import { motion } from "framer-motion";
import { useRotation } from "../../util/util";

const layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
};

const getItemStyles = (initialOffset, currentOffset) => {
  if (!initialOffset || !currentOffset) {
    return {
      display: "none",
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;

  return {
    transform,
    WebkitTransform: transform,
  };
};

const CustomDragLayer = () => {
  const rotation = useRotation();
  const { isDragging, item, initialOffset, currentOffset } = useDragLayer(
    (monitor) => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    })
  );

  if (!isDragging) {
    return null;
  }

  const imageRotation =
  rotation === "90"
    ? "rotate(90deg)"
    : rotation === "270"
      ? "rotate(270deg)"
      : "";

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(initialOffset, currentOffset)}>
        {item && (
          <motion.img
            src={item.src}
            alt={`image-${item.id}`}
            style={{ width: 256, height: 293, transform: imageRotation }}
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
          />
        )}
      </div>
    </div>
  );
};

export default CustomDragLayer;
